////////////////////////////////
// WhooosReadingServices.js ////
////////////////////////////////

var WhooosReadingServices = {
	OuterPages: {
		protocol: defaultProtocolBehavior,

		host: function() {
			if ($wr.isProduction()) {
				return "www.whooosreading.org";
			} else if ($wr.isStaging()) {
				return "www.savvashortondev.com";
			} else if ($wr.isDevelopment()) {
				return "localhost:3000";
			} else {
				throw "Unknown environment";
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

	WebApp: {
		protocol: defaultProtocolBehavior,

		host: function() {
			if ($wr.isProduction()) {
				return "app.whooosreading.org";
			} else if ($wr.isStaging()) {
				return "app.savvashortondev.com";
			} else if ($wr.isDevelopment()) {
				return "localhost:3001";
			} else {
				throw "Unknown environment";
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

	Cheshire: {
		protocol: defaultProtocolBehavior,

		host: function() {
			if ($wr.isProduction()) {
				return "cheshire.whooosreading.org";
			} else if ($wr.isDevelopment()) {
				return "localhost:30010";
			} else {
				throw "Unknown environment";
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

	FileStation: {
		protocol: function() {
			return WhooosReadingServices.OuterPages.protocol();
		},

		host: function() {
			// Check process.env here
			return WhooosReadingServices.OuterPages.host() + "/file_station";
		},

		url: function(path) {
			return this.protocol() + this.host() + path;
		}
	},

	Documents: {
		protocol: defaultProtocolBehavior,

		host: function() {
			var hostBase = WhooosReadingServices.ApiServer.host().replace("/api/v1", "")
			return hostBase + "/docs";
		},

		url: function(path) {
			return this.protocol() + this.host() + path;
		}
	},

	SsoServer: {
		protocol: defaultProtocolBehavior,

		host: function() {
			var hostBase = WhooosReadingServices.ApiServer.host().replace("/api/v1", "")
			return hostBase + "/sso";
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

	CanonicalSchools: {
		protocol: defaultProtocolBehavior,

		host: function() {
			if ($wr.isProduction() || $wr.isStaging() || ($wr.isDevelopment() && !$wr.checkCustomEnv("local-canonical-schools"))) {
				return "schools.whooosreading.org/api/v1/public";
			} else if ($wr.isDevelopment()) {
				return "localhost:3005/api/v1/public";
			} else {
				throw "Unknown environment"
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		},

		browseUrl: function(path, queryParams) {
			return this.protocol() + this.host().replace("/api/v1/public", "") + path + createQueryString(queryParams);
		}
	},

	Matilda: {
		protocol: httpsProtocolBehavior,

		host: function() {
			if ($wr.isProduction() || $wr.isStaging() || ($wr.isDevelopment() && !$wr.checkCustomEnv("local-matilda"))) {
				return "matilda.whooosreading.org/api/v1";
			} else if ($wr.isDevelopment()) {
				return "localhost:3007/api/v1";
			} else {
				throw "Unknown environment"
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

	ApiServer: {
		protocol: defaultProtocolBehavior,

		host: function() {
			if ($wr.isProduction()) {
				return "api.whooosreading.org/api/v1";
			} else if ($wr.isStaging()) {
				return "api.savvashortondev.com/api/v1";
			} else if ($wr.isDevelopment()) {
				return "localhost:3002/api/v1";
			} else {
				throw "Unknown environment"
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

	LegacyServer: {
		protocol: defaultProtocolBehavior,

		host: function() {
			if ($wr.isProduction()) {
				return "api.whooosreading.org";
			} else if ($wr.isStaging()) {
				return "api.savvashortondev.com";
			} else if ($wr.isDevelopment()) {
				return "localhost:3002";
			} else {
				throw "Unknown environment"
			}
		},

		url: function(path, queryParams) {
			return this.protocol() + this.host() + path + createQueryString(queryParams);
		}
	},

}

function defaultProtocolBehavior() {
	if ($wr.isProduction() || $wr.isStaging()) {
		return "https://";
	} else if ($wr.isDevelopment()) {
		return "http://";
	} else {
		throw "Unknown environment"
	}
}

function httpsProtocolBehavior() {
	return "https://";
}


function createQueryString(queryParams) {
	var queryString = '';
	var first = true;
	for (var queryParamName in queryParams) {
		if (first) {
			first = false;
			queryString += '?';
		} else {
			queryString += '&' ;
		}

		queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
	}

	return queryString;
}

module.exports = WhooosReadingServices;


// WEBPACK FOOTER //
// ./modules/lib/web/WhooosReadingServices.js